import './index.less'

const Modal = (function () {
    let instance;
    let isOpen = false;
    let ms = ''
    let _params = {}
    let ids = {} // 缓存content header等


    function createModal(message, params = {}, targetContainer = document.body) {
        ms = message
        _params = params

        !ids[params.id] && (ids[params.id] = {
            header: params.header ? params.header : '',
            message: message,
            class: params.class ? params.class : ''
        })

        // 创建模态框 DOM 结构
        const modal = document.createElement('div');
        modal.classList.add('modal');
        modal.classList.add('modal-container');
        const modalContent = document.createElement('div');
        modalContent.classList.add('modal-content');
        const closeBtn = document.createElement('span');
        closeBtn.classList.add('close');
        closeBtn.innerHTML = `<svg style="top: 12px;right: 6px;" class="modal__close svelte-1g8kkze" xmlns="http://www.w3.org/2000/svg" fill="#888888" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" style="stroke: rgb(136, 136, 136);"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>`;

        const messageEl = document.createElement('div');
        messageEl.classList.add('modal-content-body');
        // messageEl.textContent = message;
        if(message instanceof HTMLElement) {
            messageEl.appendChild(message)
        }
        if(typeof message === 'string') {
            messageEl.innerHTML = message
        }

        // const confirmBtn = document.createElement('div');
        // confirmBtn.classList.add('modal-content-');

        const modalHeader = document.createElement('div');
        const modalHeaderContent = document.createElement('div');
        modalHeaderContent.classList.add('moadal-header-content', 'text-overflow-2');
        modalHeaderContent.innerHTML = _params.header ? _params.header : ''
        modalHeader.classList.add('moadal-header', 'relative');
        modalHeader.appendChild(modalHeaderContent);
        modalHeader.appendChild(closeBtn);

        modalContent.appendChild(modalHeader);
        // modalContent.appendChild(closeBtn);
        modalContent.appendChild(messageEl);
        // modalContent.appendChild(confirmBtn);

        modal.appendChild(modalContent);

        // 添加事件监听器
        closeBtn.addEventListener('click', function () {
            closeModal();
        });

        // confirmBtn.addEventListener('click', function () {
        //     closeModal();
        //     if (params.cb && typeof params.cb === 'function') {
        //         params.cb();
        //     }
        // });

        // 添加到文档中
        targetContainer.appendChild(modal);

        // 显示模态框
        modal.classList.add('fade-in');
        isOpen = true;
        // 禁止body滚动
        jkyUtils?.disablePageScroll()

        if (params.cb && typeof params.cb === 'function') {
            params.cb(modal);
        }

        function closeModal() {
            const videos = modal.querySelectorAll('video, jky-video');
            videos.forEach(function (video) {
                if (video) {
                    video.pause();
                    video.muted = true;
                }
            })
            modal.classList.add('fade-out');
            modal.classList.remove('fade-in');
            modal.querySelector('.modal-content').classList.remove('fade-in');
            setTimeout(function () {
                // 是否关闭即销毁模态框
                if (params.destroyOnClose) {
                    modal.parentNode.removeChild(modal)
                    delete ids[params.id]
                    // 重置全局实例，确保下次可以创建新的模态框
                    instance = null;
                } else {
                    modal.style.display = 'none'
                    modal.classList.remove('fade-out')
                    modal.querySelector('.modal-content').classList.remove('fade-out')
                    isOpen = false
                }
                
                // 恢复body滚动
                jkyUtils?.enablePageScroll()
            }, 300);
        }
        // 按下 ESC 键关闭模态框
        document.addEventListener('keydown', function (e) {
            if (isOpen && e.keyCode === 27) {
                closeModal()
            }
        });

        // 点击模态框外部区域关闭模态框
        modal.addEventListener('click', function (e) {
            // 如果点击的是 当前 modal
            // 仅当点击的是外部容器 且允许关闭时
            if (e.target === modal && (_params.clickOutsideToClose !== false)) {
                closeModal()
            }
        })

        // 新调用更像content
        function updateMessage(newMessage) {
            ms = newMessage
            if(newMessage instanceof HTMLElement) {
                messageEl.innerHTML = ''
                messageEl.appendChild(newMessage)
            }
            if(typeof newMessage === 'string') {
                messageEl.innerHTML = newMessage
            }
        }

        function updateHeader(newMessage) {
            _params.header = newMessage || ''
            modalHeaderContent.innerHTML = newMessage;
        }

        function updateClass(newClass) {
            newClass = newClass ? newClass : 'no-class'
            modal.classList.remove(...modal.classList)
            modal.classList.add(newClass, 'fade-in', 'modal-container', 'modal');

            setTimeout(() => {
                modal.querySelector('.modal-content').classList.add('fade-in');
            }, 20);
        }

        function openModal(params) {
            updateClass(params.class)
            modal.style.display = 'flex';
            isOpen = true;

            setTimeout(() => {
                modal.querySelector('.modal-content').classList.add('fade-in');
            }, 20);

            if (params.cb && typeof params.cb === 'function') {
                params.cb(modal);
            }

            // 禁止body滚动
            jkyUtils?.disablePageScroll()
        }

        return {
            closeModal,
            openModal,
            updateMessage,
            updateHeader,
            updateClass
        };
    }

    return {
        getInstance: function (message, params = {}, targetContainer = document.body) {
            if (!instance) {
                instance = createModal(message, params, targetContainer);
                instance.updateClass(params.class)
            } else {
                !ids[params.id] && (ids[params.id] = {
                    header: params.header ? params.header : '',
                    message: message,
                    class: params.class ? params.class : ''
                })
                if (ids[params.id]) {
                    instance.updateMessage(ids[params.id].message)
                    instance.updateHeader(ids[params.id].header)
                } else {
                    if (ms !== message) {
                        instance.updateMessage(message)
                    }
                    if (params.header !== _params.header) {
                        instance.updateHeader(params.header)
                    }
                }
                instance.openModal(params)
            }
            return instance;
        },
        updateInstance: function (message, params = {}, targetContainer = document.body) {
            if (!instance) {
                instance = createModal(message, params, targetContainer);
                instance.updateClass(params.class)
            } else {
                instance.updateMessage(message);
                instance.updateHeader(params.header || '');
                instance.updateClass(params.class);
            }
            instance.openModal(params)

            return instance;
        }
    };
})();

export default Modal
